// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelsPage-HelpText_cls1__lWsX1","cls2":"PaymentChannelsPage-HelpText_cls2__kKx7d PaymentChannelsPage-HelpText_cls1__lWsX1"};